import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { ImageColumn } from '../../components/DataTable/ImageColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { ProductSummary } from '../../interfaces/Product/ProductSummary';
import { PriceColumn } from '../../components/DataTable/PriceColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import {
  GetProductsRequest,
  getProductsRequestToQueryParams,
  ProductOrderField,
} from '../../interfaces/Product/GetProductsRequest';
import { SortingOrder } from '../../interfaces/SortingOrder';
import { getUrlSuffix } from '../../utils/QueryParameter';

const columns: TableColumn<ProductSummary>[] = [
  {
    id: 'id',
    name: 'ID',
    sortable: true,
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'image',
    name: 'Küçük Resim',
    accessor: (row) => <ImageColumn url={row.imagePath} />,
    align: 'center',
  },
  {
    id: 'quantity',
    name: 'Stok',
    sortable: true,
    accessor: (row) => <TextColumn value={row.quantity.toString()} />,
  },
  {
    id: 'sku',
    name: 'Stok Kodu',
    accessor: (row) => <TextColumn value={row.sku} />,
  },
  {
    id: 'name',
    name: 'İsim',
    sortable: true,
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'price',
    name: 'Fiyat (Vergi Dahil)',
    sortable: true,
    accessor: (row) => (
      <PriceColumn
        value={row.price}
        specialValue={row.specialPrice ? row.specialPrice : undefined}
      />
    ),
  },
  {
    id: 'status',
    name: 'Durum',
    sortable: true,
    accessor: (row) => <BoolColumn value={row.isActive} sortable />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    sortable: true,
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type ProductSummariesTableProps = {
  productSummaries: ProductSummary[];
  existingFilters: GetProductsRequest;
  totalCount: number;
  orderBy: ProductOrderField;
  order: SortingOrder;
  onChangeOrder: (orderBy: ProductOrderField, order: SortingOrder) => void;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const ProductSummariesTable = (props: ProductSummariesTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.productSummaries}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      orderBy={props.orderBy}
      order={props.order}
      onOrder={(newOrderBy, newOrder) =>
        props.onChangeOrder(newOrderBy as ProductOrderField, newOrder)
      }
      onClick={(productSummary) =>
        navigate(
          `/products/catalog/${productSummary.id}${getUrlSuffix(
            getProductsRequestToQueryParams(props.existingFilters),
          )}`,
        )
      }
    />
  );
};
